function calculateDistance(x1, y1, x2, y2) {
	return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}

//doghnutLineLabel
export const doghnutLineLabel = {
	id: 'doghnutLineLabel',
	beforeDraw(chart, evt, options) {
		// Add any beforeDraw logic if needed
	},
	afterDraw(chart, evt, options) {
		// Only run for doughnut charts
		if (chart.config.type !== 'doughnut') return;

		const ctx = chart.ctx;
		const chartArea = chart.chartArea;
		const width = chart.width;
		const height = chart.height;

		chart.data.datasets.forEach( (dataset, i) => {
			chart.getDatasetMeta(i).data.forEach( (datapoint, index) =>{
				//console.log(dataset.data[index]);
				if (dataset.data[index] <= 1) {
					return;
				}
				const {x ,y} = datapoint.tooltipPosition();

				const halfHeight = height/2;
				const halfWidth = width/2;
				const xLine = x >= halfWidth ? x+5: x-5;
				const yLine = y >= halfHeight ? y+10: y-10;
				const xChange = x >= halfWidth ? 5: -5;

				const radius = Math.min(width, height) / 2.25;
				let xEdge = radius - calculateDistance(halfWidth,halfHeight,x,y);
				xEdge = x >= halfWidth ? xEdge: xEdge*-1;

				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(xLine+xEdge, yLine);
				ctx.lineTo(xLine + xChange +xEdge, yLine);
				ctx.strokeStyle = dataset.backgroundColor[index];
				ctx.stroke();

				const textWidth = ctx.measureText(chart.data.labels[index]).width;
				const textChange = x >= halfWidth ? 5: -5;
				ctx.font = '12px Arial';

				ctx.textAlign = x >= halfWidth ? 'left': 'right';
				ctx.textBaseline = 'middle';
				ctx.fillStyle = dataset.backgroundColor[index];
				ctx.fillText(chart.data.labels[index], xLine + xChange + textChange +xEdge, yLine);
			})
		})
	}
}